<template>
    <div>
        <section>
          <article>
            <div class="tour-box">
              <div class="ribbon_3 specail-offer">
                <span class="sale">Hot</span>
              </div>
              <div class="tour-img-container">
                <figure>
                  <b-nav-item to="/en/programs/post" class="link-to-tour">
                    <img src="images/homepage/tour.jpg" alt="Maltese Terrier">
                  </b-nav-item>
                  <b-row class="caption-container">
                    <b-col sm="8">
                      <b-nav-item to="programs/post">
                        <figcaption class="figcaption">تجربة جبل موسى وشروق الشمس سانت كاترين</figcaption>
                      </b-nav-item>
                    </b-col>
                    <b-col sm="4" class="review-container">
                      <span>
                        تقيم 1
                      </span>
                    </b-col>
                  </b-row>
                  <b-col>
                    <span class="stars-container">
                      <i class="icon-star" v-for="star in stars" :key="star + 'index'"></i>
                      <i class="icon-star-empty" v-for="empty in (5-stars)" :key="empty"></i>
                    </span>
                  </b-col>
                </figure>
              </div>

              <p class="description">
                جبل سيناء هو جبل يبلغ ارتفاعه 2295 مترًا (7،497 قدمًا) مرتفعًا بشكل معتدل بالقرب من مدينة سانت كاترين في...
              </p>
              <div class="price">
                <h2 class="h5">
                  <span>يبدأ من: </span>
                  <span class="the-price">45$ </span>
                </h2>
              </div>
            </div>
          </article>
        </section>
    </div>
</template>
<script type="text/javascript">


  export default {
    name:'SingleTour',
    props:['stars']
  }
</script>
